import PropTypes from 'prop-types';

import {PSR_TYPES} from '../../../constants/typesMessages';
import {useChatStore} from '../../../store/slices/chatStore';
import {usePsrStore} from '../../../store/slices/psrStore';
import PsrCodeInput from '../../PsrCodeInput';
import {PsrsGroup} from '../../PsrsGroup';

export const MessagePsrsEcommerce = (props) => {
  const psrGroupTypes = usePsrStore((state) => state.psrGroupTypes);
  const psrPaymentType = usePsrStore((state) => state.psrPaymentType);
  const sendMessage = useChatStore((state) => state.sendMessage);
  const setMessages = useChatStore((state) => state.setMessages);
  const setChatInputCode = useChatStore((state) => state.setChatInputCode);
  const setChaListCode = useChatStore((state) => state.setChaListCode);
  const setPsrInputOwnerId = useChatStore((state) => state.setPsrInputOwnerId);

  const handleSavePsrSelection = (psrNamesMessage) => {
    // Adiciona mensagem ao histórico do chat
    sendMessage({
      text: psrNamesMessage,
      type: 'message-sent'
    });
  };

  const cancelStepPsrSelection = () => {
    setChatInputCode([]);
    setChaListCode([]);
    setPsrInputOwnerId(null);

    sendMessage({text: 'Cancelar', type: 'message-sent'});

    if (psrPaymentType.physical) {
      sendMessage({type: PSR_TYPES.PSR_PHYSICAL});
      return;
    }

    sendMessage({type: PSR_TYPES.PSR_PAYMENT});
  };

  const cancelStepPsrIdMultivan = () => {
    setChatInputCode([]);
    setChaListCode([]);
    setPsrInputOwnerId(null);

    setMessages([
      {text: 'Cancelar', type: 'message-sent'},
      {
        type: PSR_TYPES.PSR_ECOMMERCE
      }
    ]);
  };

  const saveStepPsrIdMultivan = () => {
    sendMessage({
      text: 'Os dados fornecidos referentes às Maquininhas para Pagamentos Online estão corretos?',
      type: PSR_TYPES.PSR_ONFIRM_ECOMMERCE
    });
  };

  return (
    <>
      <div className="message-line">
        <div className="message-receive" id={`msg-${props.question.id}`}>
          <div className="message-div">
            <p>
              Agora, vamos para o credenciamento em{' '}
              <strong>Maquininhas para Pagamentos Online</strong>. Por favor,
              selecione abaixo qual(is) maquininha(s) você deseja habilitar.
            </p>
          </div>
        </div>
      </div>
      <PsrsGroup
        showPsr={psrGroupTypes.ecommerce}
        cancelButton={cancelStepPsrSelection}
        onSave={handleSavePsrSelection}
        stepId={props.question.id}
      />
      <PsrCodeInput
        saveButton={saveStepPsrIdMultivan}
        cancelButton={cancelStepPsrIdMultivan}
        stepId={props.question.id}
      />
    </>
  );
};

MessagePsrsEcommerce.propTypes = {
  question: PropTypes.object
};
